var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }, [_c("StoreSelect")], 1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-info",
                        "data-style": "zoom-in",
                        loading: _vm.btn_loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showReserve()
                        },
                      },
                    },
                    [_vm._v("Показать брони\n                            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-hover table-bordered" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(
                  _vm.orderedPrepNames(_vm.prep_names),
                  function (prep, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(prep.name))]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.printReserve(prep.id)),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(prep.id))]),
                    ])
                  }
                ),
                0
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Брони препаратов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Бронь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Морион")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }